<template>
    <div>{{messages}}</div>
</template>
<script>
export default {
    data: () => {
        return {
            messages: {foo: 'bar'},
        }
    }
}
</script>